exports = module.exports = require("./../../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabs{width:100%;margin:0;list-style:none;position:relative;overflow-x:auto;overflow-y:hidden;background-color:#fff;margin:0 auto;white-space:nowrap}.tabs,.tabs .tabs-item{padding:0;display:block;height:48px}.tabs .tabs-item{float:left;text-align:center;line-height:48px;margin:0;text-transform:uppercase;letter-spacing:.8px;width:15%;min-width:80px;cursor:pointer}.tabs .tabs-item,.tabs .tabs-item a{text-overflow:ellipsis;overflow:hidden}.tabs .tabs-item a{color:#ee6e73;display:block;width:100%;height:100%;-webkit-transition:color .28s ease;transition:color .28s ease}.tabs .tabs-item a:hover{color:#f9c9cb}.tabs .tabs-underline{position:absolute;bottom:0;height:2px;background:#ee6e73;-webkit-transition:left .3s,right .1s;transition:left .3s,right .1s;will-change:left,right}.tabs.tabs-auto-width{display:-webkit-box;display:-ms-flexbox;display:flex}.tabs.tabs-auto-width .tabs-item{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Components/Tabs/index.less
 ** module id = 510
 ** module chunks = 0
 **/